export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Cyrillic-392fc29e97fca985843aec728b2907cc.woff2";